const mobMenu = {
    dropdowns: document.querySelectorAll('.jsNextLvl') as NodeListOf<HTMLElement>,  

    init() {
        this.mobileMenuFn();
       
    },

    createItem(menu: HTMLElement, text: String) {
        const wrap = menu.querySelector('.jsSubmenuWrap');
      
        if (!wrap) {     
            const ul = document.createElement("ul");
            ul.classList.add('jsSubmenuWrap', 'main-nav__menu');
            ul.innerHTML = `<li class=" newlink  main-nav__back">                                
                                <svg >
                                    <use xlink:href="#chevron-double-left-regular"></use>
                                </svg>
                                <span >${text}</span>                              
                            </li>`;
            menu.prepend(ul);
        }
    },
    createEvent(item: HTMLElement) {
        const el = item.querySelector(".newlink");
        if (el) {
            el.addEventListener('click', (e) => {
                e.preventDefault();
                item.classList.remove('activeClass');
            });
        }
    },
    mobileMenuFn() {
        this.dropdowns.forEach((item) => {

            const subMenu = item.nextElementSibling as HTMLElement;
            if (subMenu) {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    const text = item.innerText;
                    this.createItem(subMenu, text);
                    subMenu.classList.add('activeClass');
                    this.createEvent(subMenu);

                });
            }

        });
    }


}

export default mobMenu;